import { onAuthStateChanged, User } from 'firebase/auth';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';

import { channelLogout } from './auth-channel';
import { initAuth } from './authentication';

let initialized = false;
let prevUserUid: ID | null = null;

const handleAuthStateChange = (user: User | null) => {
  const wasLoggedIn = prevUserUid !== null;
  prevUserUid = user?.uid ?? null;

  if (!wasLoggedIn || user) {
    return;
  }

  getErrorReporter().setUser(null);

  // Firebase auto-clears the user on token-revoked errors (e.g. password
  // changed elsewhere) and on manual signOut. Either way: broadcast so other
  // tabs sign out too, then reload so the userLoader redirects to /login.
  channelLogout();
  window.location.reload();
};

export const initAuthStateListener = async () => {
  if (initialized) {
    return;
  }
  initialized = true;

  const auth = await initAuth();
  prevUserUid = auth.currentUser?.uid ?? null;
  onAuthStateChanged(auth, handleAuthStateChange);
};

export const __resetAuthStateListenerForTests = () => {
  initialized = false;
  prevUserUid = null;
};
